import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "mediaSection" }
const _hoisted_2 = { class: "title-separator" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "sectionContainer" }
const _hoisted_5 = {
  id: "carouselIndicators",
  class: "carousel carousel-dark carousel-fade m-auto w-75",
  "data-bs-ride": "carousel"
}
const _hoisted_6 = { class: "carousel-indicators" }
const _hoisted_7 = ["data-bs-slide-to", "aria-label"]
const _hoisted_8 = ["data-bs-slide-to", "aria-label"]
const _hoisted_9 = { class: "carousel-inner" }
const _hoisted_10 = {
  key: 0,
  class: "carousel-item active"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "carousel-item"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<button class=\"carousel-control-prev\" type=\"button\" data-bs-target=\"#carouselIndicators\" data-bs-slide=\"prev\"><span class=\"carousel-control-prev-icon\" aria-hidden=\"true\"></span><span class=\"visually-hidden\">Previous</span></button><button class=\"carousel-control-next\" type=\"button\" data-bs-target=\"#carouselIndicators\" data-bs-slide=\"next\"><span class=\"carousel-control-next-icon\" aria-hidden=\"true\"></span><span class=\"visually-hidden\">Next</span></button>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("Media")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (img, key) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
              (key === 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    "data-bs-target": "#carouselIndicators",
                    "data-bs-slide-to": key,
                    class: "active",
                    "aria-current": "true",
                    "aria-label": img
                  }, null, 8, _hoisted_7))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    "data-bs-target": "#carouselIndicators",
                    "data-bs-slide-to": key,
                    "aria-label": img
                  }, null, 8, _hoisted_8))
            ], 64))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (img, key) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
              (key === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("img", {
                      src: require(`@/assets/carousel/${img}.png`),
                      class: "d-block w-100",
                      alt: "..."
                    }, null, 8, _hoisted_11)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("img", {
                      src: require(`@/assets/carousel/${img}.png`),
                      class: "d-block w-100",
                      alt: "..."
                    }, null, 8, _hoisted_13)
                  ]))
            ], 64))
          }), 128))
        ]),
        _hoisted_14
      ])
    ])
  ]))
}